//
//
//

import { inRange } from "./utils";

export default {
  name: "VueJsModalResizer",
  props: {
    minHeight: {
      type: Number,
      default: 0,
    },
    minWidth: {
      type: Number,
      default: 0,
    },
    maxWidth: {
      type: Number,
      default: Number.MAX_SAFE_INTEGER,
    },
    maxHeight: {
      type: Number,
      default: Number.MAX_SAFE_INTEGER,
    },
  },
  data() {
    return {
      clicked: false,
      size: {},
    };
  },
  computed: {
    className() {
      return { "vue-modal-resizer": true, clicked: this.clicked };
    },
  },
  mounted() {
    this.$el.addEventListener("mousedown", this.start, false);
  },
  methods: {
    start(event) {
      this.clicked = true;

      window.addEventListener("mousemove", this.mousemove, false);
      window.addEventListener("mouseup", this.stop, false);

      event.stopPropagation();
      event.preventDefault();
    },
    stop() {
      this.clicked = false;

      window.removeEventListener("mousemove", this.mousemove, false);
      window.removeEventListener("mouseup", this.stop, false);

      this.$emit("resize-stop", {
        element: this.$el.parentElement,
        size: this.size,
      });
    },
    mousemove(event) {
      this.resize(event);
    },
    resize(event) {
      var el = this.$el.parentElement;

      if (el) {
        var width = event.clientX - el.offsetLeft;
        var height = event.clientY - el.offsetTop;

        const maxWidth = Math.min(window.innerWidth, this.maxWidth);
        const maxHeight = Math.min(window.innerHeight, this.maxHeight);

        width = inRange(this.minWidth, maxWidth, width);
        height = inRange(this.minHeight, maxHeight, height);

        this.size = { width, height };
        el.style.width = width + "px";
        el.style.height = height + "px";

        this.$emit("resize", {
          element: el,
          size: this.size,
        });
      }
    },
  },
};
